import { pathOr } from 'ramda';

import { IOffer, IOfferHistory } from '../types';
import { EActionTypes, TOfferHistoryActions } from '../actions/actionTypes';

const initialState: IOfferHistory = {
  data: null,
  isFetching: false,
  isError: false,
  roomsFiltersActiveIDs: null,
  statusFiltersActiveIDs: null,
  page: 1,
  resultsOnPage: 5,
};

export const offerHistoryReducer = (
  state: IOfferHistory = initialState,
  action: TOfferHistoryActions,
): IOfferHistory => {
  switch (action.type) {
    case EActionTypes.request:
      return {
        ...state,
        isFetching: true,
        isError: false,
      };

    case EActionTypes.success:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };

    case EActionTypes.successLoadMore: {
      const prevOffers = pathOr<IOffer[]>([], ['data', 'offers'], state);

      return {
        ...state,
        isFetching: false,
        data: {
          ...action.payload,
          offers: prevOffers.concat(action.payload.offers),
        },
      };
    }

    case EActionTypes.failure:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };

    case EActionTypes.setPage:
      return {
        ...state,
        page: action.payload,
      };

    case EActionTypes.setRoomsFilter:
      return {
        ...state,
        roomsFiltersActiveIDs: action.payload,
      };

    case EActionTypes.setStatusFilter:
      return {
        ...state,
        statusFiltersActiveIDs: action.payload,
      };

    default:
      return state;
  }
};
